import { useTranslation } from "react-i18next";
import { InputWithAlert } from "@/components/ui/input-with-alert";

export const SummarySection = ({ form }) => {
  const { t } = useTranslation();

  const {
    isViewMode,
    invoiceTotalNetto,
    invoiceBrutto,
    invoiceVAT,
    invoice,
  } = form;

  // View mode
  if (isViewMode) {
    return (
      <div className='w-full'>
        <div className='text-xl font-medium pt-14 pb-6'>
          {t('invoices:summary')}
        </div>
        <div className='w-full md:w-4/12'>
          <div className='w-[96%] md:w-[49%] m-auto md:m-0'>
            <InputWithAlert
              label={t("invoices:price_netto")}
              value={`${invoice?.invoiceTotalNetto ?? 0} ${invoice?.paymentCurrency ?? ''}`}
              readOnly={true}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
            <InputWithAlert
              label={"VAT"}
              value={`${invoice?.invoiceVAT ?? 0} ${invoice?.paymentCurrency ?? ''}`}
              readOnly={true}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
            <InputWithAlert
              label={t('invoices:price_brutto')}
              value={`${invoice?.invoiceBrutto ?? 0} ${invoice?.paymentCurrency ?? ''}`}
              readOnly={true}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
          </div>
        </div>
      </div>
    );
  }

  // Create/Edit mode
  return (
    <div className='w-full'>
      <div className="w-full text-xl font-medium py-6">
        {t('invoices:summary')}
      </div>
      <InputWithAlert
        placeholder={t("phone")}
        label={t("invoices:price_netto")}
        value={isNaN(invoiceTotalNetto) ? '' : parseFloat(invoiceTotalNetto).toFixed(2)}
        onChange={() => {}}
        disabled
        inputClassName={'h-12 mt-2 mb-4 bg-white w-1/3'}
      />
      <InputWithAlert
        label="VAT"
        value={!isNaN(invoiceVAT) ? parseFloat(invoiceVAT).toFixed(2) : ''}
        onChange={() => {}}
        disabled
        inputClassName={'h-12 mt-2 mb-4 bg-white w-1/3'}
      />
      <InputWithAlert
        label={t('invoices:price_brutto')}
        value={!isNaN(invoiceBrutto) ? parseFloat(invoiceBrutto).toFixed(2) : ''}
        onChange={() => {}}
        disabled
        inputClassName={'h-12 mt-2 mb-4 bg-white w-1/3'}
      />
    </div>
  );
};
